{
  "language": {
    "name": "Svenska",
    "choose": "Språk",
    "reviewed": "yes",
    "unreviewedNotice": "Svenska är gränssnittets originalspråk."
  },
  "app": {
    "name": "Continuum",
    "banner": "AKUTJOURNAL"
  },
  "nav": {
    "ward": "Avdelningslista",
    "search": "Sök patient",
    "register": "Ny patient"
  },
  "status": {
    "checking": "Kontrollerar …",
    "ready": "Databas ansluten",
    "aliveNoDatabase": "API svarar, databas inte tillgänglig",
    "unreachable": "API svarar inte"
  },
  "action": {
    "openPatient": "Öppna patientöversikt för {name}"
  },
  "value": {
    "notRecorded": "Ej angivet",
    "unreadable": "Kan inte visas"
  },
  "identity": {
    "nameMissing": "Namn saknas",
    "age": "{years} år"
  },
  "safety": {
    "allergyActive": "Allergi",
    "allergyUnknown": "Allergi ej utredd",
    "allergyNoneKnown": "Inga kända allergier",
    "allergyUndocumented": "Allergi ej dokumenterad",
    "dnr": "DNR",
    "isolation": "Isolering: {type}",
    "estimatedIdentity": "Ej identifierad",
    "confidentialityMarked": "Skyddad identitet",
    "deceased": "Avliden"
  },
  "deployment": {
    "internetDemo": "Testmiljö på internet. Skriv aldrig in riktiga patientuppgifter — allt här är påhittat, och det du skriver kan läsas av andra som testar."
  }
}
